import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_view_class_dialog = _resolveComponent("ontos-view-class-dialog")!
  const _component_ontos_property_dialog = _resolveComponent("ontos-property-dialog")!
  const _component_ontos_workflow_dialog = _resolveComponent("ontos-workflow-dialog")!
  const _component_ontos_domain_dialog = _resolveComponent("ontos-domain-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.target && _ctx.target.kind === 'class')
      ? (_openBlock(), _createBlock(_component_ontos_view_class_dialog, {
          key: 0,
          "idea-alias": _ctx.target.idea,
          workspace: _ctx.workspace,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed'))),
          onShowMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, null, 8, ["idea-alias", "workspace"]))
      : _createCommentVNode("", true),
    (_ctx.property)
      ? (_openBlock(), _createBlock(_component_ontos_property_dialog, {
          key: 1,
          idea: _ctx.idea,
          workspace: _ctx.workspace,
          property: _ctx.property,
          saving: _ctx.saving,
          onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save-property', $event))),
          onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closed')))
        }, null, 8, ["idea", "workspace", "property", "saving"]))
      : _createCommentVNode("", true),
    (_ctx.workflow)
      ? (_openBlock(), _createBlock(_component_ontos_workflow_dialog, {
          key: 2,
          workflow: _ctx.workflow,
          workspace: _ctx.workspace,
          saving: _ctx.saving,
          onSave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('save-workflow', $event))),
          onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('closed')))
        }, null, 8, ["workflow", "workspace", "saving"]))
      : _createCommentVNode("", true),
    (_ctx.domain)
      ? (_openBlock(), _createBlock(_component_ontos_domain_dialog, {
          key: 3,
          domain: _ctx.domain,
          workspace: _ctx.workspace,
          saving: _ctx.saving,
          onSave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('save-domain', $event))),
          onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('closed')))
        }, null, 8, ["domain", "workspace", "saving"]))
      : _createCommentVNode("", true)
  ]))
}